package amazon.lastmile.inject

import app.nestbridge.feature.children.api.ChildApiClient
import app.nestbridge.feature.children.api.RemoteChildApiClient
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = RemoteChildApiClient::class)
public interface AppNestbridgeFeatureChildrenApiRemoteChildApiClient {
  @Provides
  public fun provideRemoteChildApiClientChildApiClient(remoteChildApiClient: RemoteChildApiClient): ChildApiClient = remoteChildApiClient
}
